import { ProductSupplierModelType } from '@teinor/erp/types/company/product/productSupplier'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import { permissionCheck } from '../../../../../baseComponents/PermissionChecker/function'
import TwinTable from '../../../../../baseComponents/TwinTable'
import BaseScreenTableInner from '../../../../../baseComponents/TwinTable/BaseScreenTableInner'
import { TableComponentBaseScreenInnerProps } from '../../../../../baseComponents/TwinTable/BaseScreenTableInner/types'
import { CustomRenderBoolean, CustomRenderDate, CustomRenderPrice, CustomRenderString, DeleteRow, EditRow } from '../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnTableSchema } from '../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import ModalCreateProductSupplier from './ModalCreateProductSupplier'
import ModalDeleteSupplierProduct from './ModalDeleteSupplierProduct'
import ModalEditProductSupplier from './ModalEditProductSupplier'
import { ProductExtendedTyShort } from '../../../types'


interface SuppliersProductProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
}

const SuppliersProduct: React.FC<SuppliersProductProps> = ({ basicData, userPermissions }) => {
    const { t } = useTwinTranslation()

    const pageData = {
        title: t('suppliers', 'Proveedores'),
        newText: t('addSupplier', 'Añadir nuevo proveedor')
    }

    return (
        <BaseScreenTableInner TableComponent={TableSuppliersProduct} CreateModalComponent={ModalCreateProductSupplier} EditModalComponent={ModalEditProductSupplier} DeleteModalComponent={ModalDeleteSupplierProduct} pageData={pageData} userPermissions={userPermissions} extraWhereParams={{ ProductId: basicData?.id }} />
    )
}
type TableSuppliersProductProps = TableComponentBaseScreenInnerProps

const TableSuppliersProduct: React.FC<TableSuppliersProductProps> = ({ setOpened, setTableInstance, userPermissions, extraWhereParams }) => {
    const { t } = useTwinTranslation()
    const columns: ColumnTableSchema<ProductSupplierModelType> = [
        {
            id: 'SupplierId',
            dataKey: 'SupplierId',
            label: t('supplier', 'Proveedor'),
            minWidth: 140,
            searchKey: 'Supplier.name',
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('supplierReference', 'Referencia del proveedor'), }
            },
            customRender: (_parameterValue, allRowData) => <CustomRenderString value={allRowData?.Supplier?.name} />,
        },
        {
            id: 'supplier_reference',
            dataKey: 'supplier_reference',
            label: t('supplierRefShort', 'Ref. Prov.'),
            simpleLabel: t('supplierRefLong', 'Referencia Proveedor'),
            toolTip: t('supplierRefLong', 'Referencia Proveedor'),
            minWidth: 170,
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('supplierReference', 'Referencia del proveedor'), }
            }
        },
        {
            id: 'delivery_time',
            dataKey: 'delivery_time',
            label: t('deliveryTime', 'Tiempo de entrega'),
            minWidth: 140,
        },
        {
            id: 'last_buy_date',
            dataKey: 'last_buy_date',
            label: t('lastBuyDate', 'Fecha última compra'),
            customRender: (parameterValue, allRowData) => <CustomRenderDate value={parameterValue} {...{ allRowData }} />
        },
        {
            id: 'last_price',
            dataKey: 'last_price',
            label: t('lastPrice', 'Último precio'),
            minWidth: 110,
            customRender: (parameterValue, allRowData) => <CustomRenderPrice value={parameterValue} {...{ allRowData }} />
        },
        {
            id: 'default_supplier',
            dataKey: 'default_supplier',
            label: t('defaultSupplier', 'Proveedor por defecto'),
            minWidth: 160,
            customRender: (parameterValue) => <CustomRenderBoolean value={String(parameterValue) === 'true'} width={143} />
        },
        {
            id: 'edit',
            dataKey: 'supplier_reference',
            label: '',
            width: 50,
            simpleLabel: t('edit', 'Editar'),
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} />,
        },
        {
            id: 'delete',
            dataKey: 'supplier_reference',
            label: '',
            width: 50,
            simpleLabel: t('delete', 'Eliminar'),
            customRender: (parameterValue, allRowData) => <DeleteRow key={'delete' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'delete', allRowData })} />,
            havePermission: permissionCheck(userPermissions, 'delete')
        }
    ]
    return (
        <TwinTable columns={columns} name='productSuppliers' getDataFrom='/api/app/product/productSupplier/getAllProductSuppliersComplete' 
            onRowClick={(_id, rowData) => setOpened({
                type: 'edit',
                allRowData: rowData
            })} setTableInstance={setTableInstance} defaultOrder={{ order: 'desc', defaultOrderField: 'SupplierId' }} extraWhereParams={extraWhereParams} />
    )
}


export default SuppliersProduct